import { render, staticRenderFns } from "./PrimePage.vue?vue&type=template&id=b447e994&scoped=true"
import script from "./PrimePage.vue?vue&type=script&lang=js"
export * from "./PrimePage.vue?vue&type=script&lang=js"
import style0 from "./PrimePage.vue?vue&type=style&index=0&id=b447e994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b447e994",
  null
  
)

export default component.exports